import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { WIZARD_COLORS } from '../../../components/FormComponents/dynamicForm';
var StepPanelHeader = function (_a) {
    var icon = _a.icon, title = _a.title, action = _a.action, _b = _a.isSubHeading, isSubHeading = _b === void 0 ? false : _b;
    return (React.createElement(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            flexWrap: 'wrap',
            marginBottom: isSubHeading ? '10px' : '14px',
        } },
        React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 } },
            React.createElement(Box, { "aria-hidden": true, sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 28,
                    height: 28,
                    flexShrink: 0,
                    borderRadius: '8px',
                    backgroundColor: WIZARD_COLORS.subHeading,
                    color: WIZARD_COLORS.body,
                    '& svg': { fontSize: 17 },
                } }, icon),
            React.createElement(Typography, { component: isSubHeading ? 'h3' : 'h2', sx: { fontSize: isSubHeading ? 15 : 16, fontWeight: 700, color: WIZARD_COLORS.ink } }, title)),
        action));
};
export default React.memo(StepPanelHeader);
